<template>
  <div :id='id'></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themesAnimated from '@amcharts/amcharts4/themes/animated';

/* Chart code */
am4core.options.queue = true;
// Themes begin
am4core.useTheme(am4themesAnimated);
am4core.addLicense('CH315878972');
// Themes end

export default {
  props: {
    id: {
      type: String,
      default: 'chartdiv',
    },
    colors: {
      type: Array,
      default: () => ['#f799d1', '#e04074'],
    },
    data: {
      type: Array,
      default: () => [],
    },
    yAxis: {
      type: Object,
      default: () => ({
        label: 'name',
      }),
    },
    xAxis: {
      type: Object,
      default: () => ({
        label: 'value',
      }),
    },
  },
  mounted() {
    const self = this;
    // Create chart instance
    const chart = am4core.create(this.id, am4charts.XYChart);
    const chartContainer = document.getElementById(this.id);
    chartContainer.style.width = '100%';
    chartContainer.style.height = '30em';

    // Add data
    const sortedData = [...this.data];
    sortedData.sort((a, b) => a.Year - b.Year);
    chart.data = sortedData;
    chart.numberFormatter.numberFormat = '####.##';
    // chart.responsive.enabled = true;

    // Create axes
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = self.xAxis.label;
    categoryAxis.renderer.grid.template.opacity = 0;
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 20;
    categoryAxis.renderer.cellStartLocation = 0;
    categoryAxis.renderer.cellEndLocation = 0.9;
    categoryAxis.title.text = this.xAxis.label;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.opacity = 0;
    valueAxis.title.text = this.yAxis.label;
    // valueAxis.renderer.labels.template.disabled = true;
    valueAxis.min = 0;

    // Create series
    function createSeries(field, name, color, stacked) {
      const series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = field;
      series.dataFields.categoryX = self.xAxis.label;
      series.name = name;
      series.columns.template.tooltipText = '{name}: [bold]{valueY}[/]';
      series.columns.template.fill = am4core.color(color);
      series.columns.template.strokeOpacity = 0;
      series.stacked = stacked;
      series.columns.template.width = am4core.percent(100);
      const labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.truncate = false;
      labelBullet.fontSize = 16;
      labelBullet.properties.rotation = -90;
      labelBullet.dy = 25;
      labelBullet.label.text = `{${field.toString()}}`;
      labelBullet.label.fill = am4core.color('black');
      series.columns.template.events.on('sizechanged', (ev) => {
        if (ev.target.dataItem && ev.target.dataItem.bullets) {
          const height = ev.target.pixelHeight;
          ev.target.dataItem.bullets.each((id, bullet) => {
            if (height > 50) {
              bullet.dy = 25;
            } else {
              bullet.dy = -25;
            }
          });
        }
      });
    }
    chart.responsive.enabled = true;
    chart.responsive.useDefault = false;
    chart.responsive.rules.push({
      relevant(target) {
        if (target.pixelWidth <= 400) {
          return true;
        }
        return false;
      },
      state(target, stateId) {
        if (target instanceof am4charts.AxisRendererY) {
          const state = target.states.create(stateId);
          state.properties.disabled = true;
          return state;
        }
        if (target instanceof am4charts.AxisRendererX) {
          const state = target.states.create(stateId);
          state.properties.fontSize = 12;
          return state;
        }
        if (target instanceof am4charts.LabelBullet) {
          const state = target.states.create(stateId);
          state.properties.fontSize = 12;
          state.properties.dy = 20;
          return state;
        }
        return null;
      },
    });

    createSeries('Primary', 'Primary', this.colors[0], false);
    createSeries('Secondary', 'Secondary', this.colors[1], false);
    createSeries('Nursery', 'Nursery', this.colors[2], false);
    createSeries('Independant', 'Independant', this.colors[3], false);

    // Add legend
    chart.legend = new am4charts.Legend();
  },
};
</script>

<style></style>
